module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_8023.b06923b3.png";